var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Observer } from 'mobx-react-lite';
import moment from 'moment';
import React from 'react';
import ColorTag from '../../components/ColorTag/ColorTag';
import ColorTag18Plus from '../../components/ColorTag/ColorTag18Plus';
import ColorTagArchived from '../../components/ColorTag/ColorTagArchived';
import ColorTagFrontLineWorkers from '../../components/ColorTag/ColorTagFrontLineWorkers';
import ColorTagSpecialistGroup from '../../components/ColorTag/ColorTagSpecialistGroup';
import ColorTagYoungPeople1214 from '../../components/ColorTag/ColorTagYoungPeople1214';
import ColorTagYoungPeople1517 from '../../components/ColorTag/ColorTagYoungPeople1517';
import { AgeGroupFilterType } from '../../constants/ageGroups.enum';
import { CLOCK } from '../../controllers/util-level/clock.controller';
import { getAppLink } from '../../env';
import { useSupportGroupGetters } from '../../hooks/useSupportGroupGetters.hook';
import joinClassName from '../../utils/className.utils';
import { useProps, useStore } from '../../utils/mobx.utils';
import BaseCalendarEvent from '../BaseCalendar/BaseCalendarEvent';
import Redirector from '../Redirector/Redirector';
import SupportGroupJoinedCountDisplay from '../SupportGroupJoinedCountDisplay/SupportGroupJoinedCountDisplay';
import TimeDisplayer from '../TimeDisplayer/TimeDisplayer';
import UsernameRenderer from '../UsernameRenderer/UsernameRenderer';
import './SupportGroupCalendarEventRenderer.scss';
var SupportGroupCalendarEventRenderer = function (props) {
    var p = useProps(props);
    var s = useStore(function () { return ({
        get event() {
            return p.calendarEvent;
        },
        get supportGroup() {
            return s.event.data;
        },
        get hasEnded() {
            var _a, _b;
            return ((_a = s.supportGroup) === null || _a === void 0 ? void 0 : _a.timeEnded) && moment((_b = s.supportGroup) === null || _b === void 0 ? void 0 : _b.timeEnded).isBefore(CLOCK.localNowMoment);
        },
        get isArchived() {
            var _a;
            return (_a = s.supportGroup) === null || _a === void 0 ? void 0 : _a.timeArchived;
        },
    }); });
    var sg = useSupportGroupGetters(s.supportGroup);
    return React.createElement(Observer, { children: function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
            return (React.createElement(BaseCalendarEvent, __assign({}, p, { className: joinClassName("SupportGroupCalendarEventRenderer", sg.isInThePast && 'inThePast', sg.hasJoined && 'joined', sg.isLive && 'isLive', sg.isForFrontLineWorkers && 'for-front-line-workers', s.isArchived && 'archived', "support-group-summary"), "data-name": "OK", color: (_c = (_b = (_a = s.supportGroup) === null || _a === void 0 ? void 0 : _a.topic) === null || _b === void 0 ? void 0 : _b.color) !== null && _c !== void 0 ? _c : (_d = s.supportGroup) === null || _d === void 0 ? void 0 : _d.color }),
                React.createElement(Redirector, { url: getAppLink("/app/support-groups?supportGroupId=" + ((_e = s.supportGroup) === null || _e === void 0 ? void 0 : _e.id)), title: "Support Group App URL", shouldRedirect: true },
                    React.createElement("h3", null, sg.title),
                    ((_f = sg.supportGroup) === null || _f === void 0 ? void 0 : _f.facilitator) && React.createElement(UsernameRenderer, { user: (_g = sg.supportGroup) === null || _g === void 0 ? void 0 : _g.facilitator }),
                    ((_h = s.supportGroup) === null || _h === void 0 ? void 0 : _h.requiresKeyWorkerInformation) && React.createElement("strong", { className: "SupportGroupCalendarEventRendererKeyWorker" }, "Key Worker Info Required"),
                    React.createElement("div", null, !sg.isInThePast && React.createElement(SupportGroupJoinedCountDisplay, { supportGroup: s.supportGroup })),
                    sg.isForFrontLineWorkers && React.createElement(ColorTagFrontLineWorkers, null),
                    sg.hasJoined && React.createElement(ColorTag, { color: "positive" }, "Registered"),
                    sg.isLive && React.createElement(ColorTag, { color: "red" }, "Live"),
                    s.hasEnded && false && React.createElement("span", { className: "SupportGroupCalendarEventRendererEndedAt" },
                        "Ended at ",
                        React.createElement(TimeDisplayer, { value: (_j = s.supportGroup) === null || _j === void 0 ? void 0 : _j.timeEnded })),
                    s.isArchived && React.createElement(ColorTagArchived, null),
                    (((_k = s.supportGroup) === null || _k === void 0 ? void 0 : _k.ageGroups.includes(AgeGroupFilterType.youngPeople1214)) || ((_l = s.supportGroup) === null || _l === void 0 ? void 0 : _l.ageGroups.includes(AgeGroupFilterType.youngPeople1517))) && React.createElement(React.Fragment, null,
                        ((_m = s.supportGroup) === null || _m === void 0 ? void 0 : _m.ageGroups.includes(AgeGroupFilterType.youngPeople1214)) && React.createElement(ColorTagYoungPeople1214, { useAbbr: true }),
                        ((_o = s.supportGroup) === null || _o === void 0 ? void 0 : _o.ageGroups.includes(AgeGroupFilterType.youngPeople1517)) && React.createElement(ColorTagYoungPeople1517, { useAbbr: true }),
                        ((_p = s.supportGroup) === null || _p === void 0 ? void 0 : _p.ageGroups.includes(AgeGroupFilterType.adults)) && React.createElement(ColorTag18Plus, null)),
                    false && React.createElement(ColorTagSpecialistGroup, null))));
        } });
};
export default SupportGroupCalendarEventRenderer;
